import React from "react";
import Home from "./Home";
import { isStringValidated } from "./Global/Constant";
import axios from "axios";
import { SweetAlerts } from "./Global/SweetAlert";
import "./Global/Global.css";
// import { Icon } from "office-ui-fabric-react";
import { initializeIcons } from "@fluentui/react";
import { QuestionCircle24Regular } from "@fluentui/react-icons";
import { AuthService } from "../services/authService";
const WhiteHalfNavImage : any = require("../../../assets/CLM365-White-halfnav.png")
// import { useAppContext } from "../MSGraph/AppContext";
function WordAddIn() {
  initializeIcons();
  const [siteURLValue, setsiteURLValue] = React.useState<any>("");
  const [loader, setLoader] = React.useState(false);
  // const [siteURLValue,setsiteURLValue]=React.useState<any>()
  const [TokenValue, setTokenValue] = React.useState(null);
  const [currentUserData, setCurrentUserData] = React.useState({});
  const [runOrderWise, setRunOrderWise] = React.useState({
    ShowLogin: false,
    ShowApp: false,
    ShowTokenExpired: false,
  });
  const authService = new AuthService();
  const {
    SweetAlert: SweetalertLogin,
    SweetPrompt: SweetPromptLogin,
    SweetConfirmPrompt: SweetConfirmAccessPrompt,
    SweetConfirmWithoutBtnPrompt: SweetConfirmWithoutBtnAccessPrompt,
  } = SweetAlerts("#SweetalertLogin");

  React.useEffect(() => {
    getInitialData()
  }, []);

  const getInitialData=()=>{
    setLoader(true);
    const token = localStorage.getItem("CurrentToken");
    const currentUser = JSON.parse(localStorage.getItem("CurrentUser") || "{}");
    const siteURL = localStorage.getItem("SiteURL") || "";
    setsiteURLValue(siteURL);
    setCurrentUserData(currentUser);
    setTokenValue(token);
    setRunOrderWise((c) => ({
      ...c,
      ShowLogin: Object.keys(currentUser)?.length == 0 || false,
      ShowApp: isStringValidated(siteURL) && Object.keys(currentUser)?.length > 0 && isStringValidated(token),
    }));

    if (isStringValidated(siteURL) && Object.keys(currentUser)?.length > 0 && isStringValidated(token)) {
      getSettingsListData();
    } else {
      setLoader(false);
    }
  }
  const signInOutlook = async () => {
    await authService.initialize();
    const authResult = await getCurrentUserDetails();
    if (authResult) {
      let domainName = authResult.account.username?.split("@")[1]?.split(".")[0] || "";
      // console.log(domainName, "Domain name");
      const postData = {
        UserTenant: domainName,
        CLMCode:"CLM"
      };
      const url =
        "https://prod-27.centralindia.logic.azure.com:443/workflows/abd0fd21d1e74a0d8799f663183f9199/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=JCCa0LvJT0wMFUuDlG9gxjp-fEtpn5H2tuvvTho3_8s";
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          // console.log(response,'response sigin')
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json(); // Parse the JSON response
        })
        .then((data) => {
          // console.log("Response:", data?.d?.results[0]?.NewTenant?.split(".sharepoint.com")[0]?.split("//")[1]);
          localStorage.setItem(
            "TenantURL",
            data?.d?.results[0]?.NewTenant?.split(".sharepoint.com")[0]?.split("//")[1]
          );
        })
        .then(async () => {
          // await loadCertificate();
          await loginWithCredential(authResult);
          await getSettingsListItems();
          // await getSettingsListItems();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  const loginWithCredential = async (authResult: any) => {
    try {
      let token = null;
      const currentUserObject = {
        currentUserName: "",
        currentUserId: "",
        currentUserEmail: "",
      };

      // await getTenant()
      //   await authService.initialize();
      //   const authResult = await getCurrentUserDetails();

      if (authResult) {
        // Successfully authenticated
        token = authResult.accessToken;
        currentUserObject.currentUserName = authResult.account.name;
        currentUserObject.currentUserId = authResult.account.homeAccountId;
        currentUserObject.currentUserEmail = authResult.account.username;

        setCurrentUserData(currentUserObject);
        setTokenValue(authResult.accessToken);
        const activityLogs = [];
        localStorage.setItem("CurrentToken", token);
        localStorage.setItem("CurrentUser", JSON.stringify(currentUserObject));
        localStorage.setItem("ActivityLogs", JSON.stringify(activityLogs));

        // setRunOrderWise((c) => ({
        //   ...c,
        //   ShowLogin: false,
        //   ShowApp: true,
        // }));

        // console.log("Authentication successful:", authResult.account.username);
      }
    } catch (error) {
      console.error("Authentication error:", error);
      const errorData = {
        errorMessage: error.errorCode || "Unknown error",
        message: error.errorMessage || error.message,
        errorCode: error.stack,
      };
    }
  };

  async function getCurrentUserDetails(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log("Parent: Initiating login");
        const authResult = await authService.login();
        // console.log("Parent: Authentication successful", authResult);
        resolve(authResult);
      } catch (error) {
        console.error("Parent: Authentication failed", error);
        reject(error);
      }
    });
  }

  async function getSettingsListItems() {
    // console.log(`${localStorage?.getItem("CurrentToken")}`);
    let TenantURL = `https://${localStorage?.getItem("TenantURL")}.sharepoint.com`;
    try {
      if (isStringValidated(TenantURL)) {
        const apiUrl = `${TenantURL}/_api/web/lists/getbytitle('CLM365Settings')/items`;
        await axios
          .get(apiUrl, {
            headers: {
              Authorization: `Bearer ${localStorage?.getItem("CurrentToken")}`, // Include the access token
              Accept: "application/json;odata=nometadata",
              "odata-version": "",
            },
          })
          .then((response) => {
            if (response.status !== 200) {
              checkTokenExpiration(response.status);
            }
            return response.data;
          })
          .then(async (data) => {
            // SettingListID = data?.value[0].ID;
            localStorage.setItem("SiteURL", data?.value[0]?.SiteUrl);
            setsiteURLValue(data?.value[0]?.SiteUrl);
            fetchAppUsers();
            getSettingsListData();

            // const appUsers = await fetchAppUsers();

            //  const currentUserExist=appUsers?.filter(user=>user.key?.toLowerCase()==currentUserData?.currentUserEmail?.toLowerCase()&& user?.userStatus != 'Inactive');

            //  if(currentUserExist?.length==0){
            //   checkTokenExpiration(true)
            //  }else{
            //   checkTokenExpiration(false)
            //  }
            // localStorage.setItem("MailTrackerSiteURL", data?.value[0]?.SiteUrl);
            // document.getElementById("loader").style.display = "none";
            // localStorage.setItem("AppUrlLink", data?.value[0]?.AppUrl);
            // document.getElementById("portalLink").href = data?.value[0]?.AppUrl;
          })
          .catch((error) => {
            console.error("Error fetching list items:", error);
          });
      }
    } catch {
      console.log("error while getting settings list data");
    }
  }
  async function checkTokenExpiration(SiteResponse) {
    const AccessTOKEN = localStorage.getItem("CurrentToken");
    if (isStringValidated(AccessTOKEN)) {
      if (SiteResponse == 401) {
        // const Unauthorized = `Your session has expired, or you are not currently logged in. Please log in again to continue accessing this app.`;
        // setRunOrderWise((c) => ({
        //   ...c,
        //   ShowLogin: true,
        //   ShowApp: false,
        //   ShowTokenExpired: true,
        // }));
        // SweetConfirmAccessPrompt("warning", Unauthorized).then((result) => {
        //   if (result.isConfirmed) {
        //     RefreshPage();  
        //   }
        // });
       await getRefreshTokenSilently()
      } else if (SiteResponse == 403) {
        const Unauthorized = `Looks like you don't have sufficient permissions of the site. Please contact with your site administrator.`;
        setRunOrderWise((c) => ({
          ...c,
          ShowLogin: false,
          ShowApp: false,
          ShowTokenExpired: true,
        }));

        SweetConfirmWithoutBtnAccessPrompt("warning", Unauthorized);
      } else if (SiteResponse == 404) {
        const Unauthorized = `It appears the system is not yet set up to continue this app. Please contact your app administrator for further assistance`;
        setRunOrderWise((c) => ({
          ...c,
          ShowLogin: false,
          ShowApp: false,
          ShowTokenExpired: true,
        }));
        SweetConfirmWithoutBtnAccessPrompt("warning", Unauthorized);
      } else if (SiteResponse == "UserNotExistInApp") {
        const Unauthorized = `You do not have access to the CLM365 - Contract Management app. Please contact your app administrator to request access.`;
        setRunOrderWise((c) => ({
          ...c,
          ShowLogin: false,
          ShowApp: false,
          ShowTokenExpired: true,
        }));
        SweetConfirmWithoutBtnAccessPrompt("warning", Unauthorized);
      } else {
        setRunOrderWise((c) => ({
          ...c,
          ShowLogin: false,
          ShowApp: true,
          ShowTokenExpired: false,
        }));
      }
    } else {
      setRunOrderWise((c) => ({
        ...c,
        ShowLogin: true,
        ShowApp: false,
        ShowTokenExpired: false,
      }));
    }
  }



  const getRefreshTokenSilently = async () => {
    try {
      // console.log("Attempting silent token refresh...");
      
      // const authService = new AuthService(); // Create an instance of your AuthService
      const authResult = await authService.acquireTokenSilently();
      // console.log(authResult?.accessToken,'Access TOken refresh')
      if (authResult?.accessToken) {
        // console.log("Token refresh successful!");
        localStorage.setItem("CurrentToken", authResult.accessToken);
        getInitialData()
        // return authResult.accessToken;
      }
    } catch (error) {
      console.error("Silent token refresh failed:", error);
      throw error;
    }
  };


  const fetchAppUsers = async () => {
    const token = localStorage.getItem("CurrentToken");
    const siteUrl = localStorage.getItem("SiteURL");
    const url =
      "/_api/web/lists/getbytitle('CLM365Users')/items?$select=*,UserStatus,GuidID,SPUser/Title,SPUser/ID,SPUser/EMail&$expand=SPUser";
    const allUsersOptions = [];
    try {
      const response = await axios.get(`${siteUrl}${url}`, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status !== 200) {
        checkTokenExpiration(response.status);
        return;
      }
      const items = response?.data.value || [];
      items?.map((user) => {
        if(user?.userStatus != "Inactive"){
        allUsersOptions.push({
          key: user.email,
          text: user?.SPUser?.Title,
          value:user.email,
          label: user?.SPUser?.Title,
          id: user?.SPUser?.ID,
          userStatus: user?.UserStatus,
          userRole: user?.Role
        });
          }
      });
      const currentUserDetails = JSON.parse(localStorage.getItem("CurrentUser") || "{}");
         localStorage.setItem("AllUsers",JSON.stringify(allUsersOptions))
      const CurrentUser = allUsersOptions?.find((i)=>i.key?.toLowerCase() === currentUserDetails.currentUserEmail?.toLowerCase())
      localStorage.setItem('CurrentAppUser',JSON.stringify(CurrentUser))
      const currentUserExist = allUsersOptions?.filter(
        (user) =>
          user.key?.toLowerCase() == currentUserDetails?.currentUserEmail?.toLowerCase() &&
          user?.userStatus != "Inactive"
      );

      if (currentUserExist?.length == 0) {
        checkTokenExpiration("UserNotExistInApp");
      } else {
        checkTokenExpiration(200);
      }
    } catch (error) {
      if (error?.status) {
        checkTokenExpiration(error.status);
      }
      console.log(error);
    }
  };

  const getSettingsListData = async () => {
    // console.log("Fetching settings data...");
    const token = localStorage.getItem("CurrentToken");
    const siteUrl = localStorage.getItem("SiteURL");

    // Ensure siteUrl exists before making a request
    if (!siteUrl) {
      console.error("Site URL is missing in localStorage.");
      return;
    }

    const endpoint = `${siteUrl}/_api/web/lists/getbytitle('CLM365Settings')/items?$select=*,AzureAI,CopilotIntegration,ID`;

    try {
      // Make API request
      const response = await axios.get(endpoint, {
        headers: {
          Accept: "application/json;odata=nometadata",
          "odata-version": "",
          Authorization: `Bearer ${token}`, // Include the token here
        },
      });

      // Check if the response is successful
      // console.log(response.status, "Status");
      if (response.status === 200 && response.data?.value) {
        const settingsData = response.data.value || [];

        // console.log(settingsData, "Settings Data");
     
        if (settingsData.length > 0) {
          const azureAISettings = settingsData[0]?.AzureAI;
          const CopilotData = settingsData[0]?.CopilotIntegration
          const settingsListID = settingsData[0]?.ID || 1; // Default to 1 if undefined

          // console.log(azureAISettings, "Azure AI Settings");
          // console.log(settingsListID, "Settings List ID");

          // Store Azure AI settings if valid
          if (azureAISettings && azureAISettings.trim() !== "") {
            try {
              const azureOpenAIData = JSON.parse(azureAISettings);
              localStorage.setItem("AzureAI", JSON.stringify(azureOpenAIData));
              localStorage.setItem("Copilot",CopilotData)
            } catch (parseError) {
              console.error("Error parsing AzureAI settings:", parseError);
            }
          }

          // Store Settings List ID
          localStorage.setItem("settingsListID", settingsListID.toString());
          setLoader(false)
        }
      }
    } catch (error) {
      if (error.response) {
        // Check if the error is related to expired token (401 Unauthorized)
        if (error.response.status === 401) {
          await checkTokenExpiration(401);
          console.error("Token has expired or is invalid. Please refresh your token.");
          // You can handle token refresh logic here if you have a refresh token.
        } else {
          console.error(`API request failed with status: ${error.response.status}`);
        }
      } else {
        console.error("Network error or no response received:", error.message);
      }
    }
  };
  const RefreshPage = () => {
    localStorage.clear();
    // document.getElementById("tasPaneComponent").style.display = "none";
    setsiteURLValue("");
    setTokenValue("");
    setCurrentUserData({});
    setRunOrderWise((c) => ({
      ...c,
      ShowTokenExpired: false,
      ShowLogin: true,
      ShowApp: false,
    }));
    setLoader(false)
  };

  const signOutCredential = () => {
    SweetPromptLogin("warning", "Are you sure you want to Sign out?").then((c) => {
      if (c.isConfirmed) {
        localStorage.clear();
        // document.getElementById("loginBtn").style.display = "flex";
        // document.getElementById("tasPaneComponent").style.display = "none";
        setsiteURLValue("");
        setTokenValue("");
        setCurrentUserData({});
        setRunOrderWise((c) => ({
          ...c,
          ShowTokenExpired: false,
          ShowLogin: true,
          ShowApp: false,
        }));
        // Office.addin.hide();
      }
    });
  };

  return (
    // <Provider store={store} >
    <>
      {!loader && (
        <div id="SweetalertLogin">
          {runOrderWise?.ShowLogin ? (
            <>
              <div className="login_container" id="beforeLogin">
              <div className="HeadingLabel" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
              {/* Sign in to <br></br> */}
              <img src={WhiteHalfNavImage} style={{height:'25px',width:'25px'}}/>
              CLM365 for Word
            </div>
            <div className="textDiv">
              <div>Easily integrate Microsoft Word with</div>
              {/* <div> </div> */}
              <div>Apps365's AI-powered Contract Management solution.</div>
              {/* <div></div> */}
            </div>

                <div className="loginCard">
                  <button id="loginBtn" className="Loginbtn" onClick={signInOutlook}>
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                      alt="Microsoft Logo"
                      className="logo"
                    />
                    Sign in with Microsoft
                  </button>
                </div>
              </div>
              <div className="TermsConditions">
                By logging in, you agree to the{" "}
                <a href="https://www.apps365.com/end-user-license-agreement-eula/">Terms of Use</a>
              </div>
            </>
          ) : null}
          {runOrderWise?.ShowApp ? (
            <Home siteURL={siteURLValue} />
          ) : null}

          {runOrderWise?.ShowApp ? (
            <div className="footerSection">
              <footer id="footer-partial" className="helpsection">
                <div className="wrapper">
                  {/* <Icon iconName="Help" /> */}
                  <QuestionCircle24Regular style={{ width: '18px' }}/>
                  <a href="https://apps365.com/support" target="_blank" rel="noopener noreferrer">
                    Help
                  </a>
                  <div>26.0115.1630.0000</div>
                </div>
                <div className="wrapper">
                  <button id="logoutBtn" onClick={signOutCredential}>
                    Sign out
                  </button>
                </div>
              </footer>
            </div>
          ) : null}
        </div>
      )}
    </>
    //  </Provider>
  );
}

export default WordAddIn;
